import { ApiError } from "./Actions";

type CheckFunction = (res: Response) => Response | any;

const checkErrorInterval: (allowedLowerInclusive: number, allowedUpperExclusive: number) => CheckFunction = (allowedLowerInclusive, allowedUpperExclusive) => res => {
  if (res.status >= allowedLowerInclusive && res.status < allowedUpperExclusive) {
    return res;
  }
  return res.text().then(text => {
    const error = new ApiError(res.statusText);
    error.response = `${res.status}: ${text || res.statusText}`;
    error.status = res.status;
    error.data = text;
    error.requestUrl = res.url;
    error.requestUuid = res.headers.get('x-snoam-request-uuid');
    throw error;
  });
};
export const checkError: CheckFunction = checkErrorInterval(200, 300);
export const checkErrorAllowSeeOther: CheckFunction = checkErrorInterval(200, 304);

export default checkError;
